import actions from '../utils/restActions';
import { customRequest} from '../utils/restUtils';

export const loadStreamings = () => {
    return (dispatch) => {
	return customRequest(actions.streamings.index, {}).then((res) => {
	    return dispatch({ type: actions.streamings.index.status.success, data: res});
	})
    }
}

export const saveStreaming = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.streamings.create, {streamings: data})
    }
}

export const updateStreaming = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.streamings.update, {id: data.id, streamings: data})
    }
}


export const removeStreaming = (data) => {
    return (dispatch) => {		   
	return customRequest(actions.streamings.delete, data)
    }
}





// WEBPACK FOOTER //
// ./src/actions/Streamings.js